import React from "react";

export default function SQLServer_DATEPART() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DATEPART</h1>
      <p>This is the SQLServer_DATEPART component generated from the SQL JSON.</p>
    </div>
  );
}
